export default __webpack_public_path__ + "static/media/NU.88af49e6.svg";